/** Mapeamento estável do REFO Band (A–F) sobre o catálogo WAYBEE.018. */
export const REFO_LETTER_COLORS = {
  A: "#e53935",
  B: "#fb8c00",
  C: "#f9a825",
  D: "#8e24aa",
  E: "#3949ab",
  F: "#00897b"
};

/** Relógio HH:mm a partir de ISO ou de "HH:mm[:ss]", sem converter fuso. */
export function formatLessonClock(value) {
  if (value == null || value === "") return "";
  const raw = String(value).trim();
  const iso = raw.match(/T(\d{2}):(\d{2})/);
  if (iso) return `${iso[1]}:${iso[2]}`;
  const clock = raw.match(/^(\d{1,2}):(\d{2})/);
  if (clock) return `${clock[1].padStart(2, "0")}:${clock[2]}`;
  return "";
}

export function formatLessonLabel(lesson) {
  if (!lesson) return "";
  const name = lesson.name || "";
  const start = formatLessonClock(lesson.startTime || lesson.HORAINICIAL);
  const end = formatLessonClock(
    lesson.endTime || lesson.EndTime || lesson.HORAFINAL
  );
  const time = [start, end].filter(Boolean).join(" - ");
  return time ? `${name} (${time})` : name;
}

export const REFO_LETTER_DEFS = [
  { letter: "A", kind: "absence" },
  {
    letter: "B",
    kind: "occurrence",
    groupIds: ["8"],
    typeIds: ["1016"],
    preferSingle: true,
    nameIncludes: [
      "AUSÊNCIA DE TAREFA",
      "AUSENCIA DE TAREFA",
      "NÃO APRESENTOU TAREFA",
      "NAO APRESENTOU TAREFA"
    ]
  },
  {
    letter: "C",
    kind: "occurrence",
    groupIds: ["7", "2"],
    typeIds: ["1015", "243"],
    preferSingle: true,
    nameIncludes: ["MATERIAL", "UNIFORME"]
  },
  {
    letter: "D",
    kind: "occurrence",
    groupIds: ["62"],
    nameIncludes: ["ATITUDE", "INADEQUAD"]
  },
  {
    letter: "E",
    kind: "occurrence",
    groupIds: ["61"],
    nameIncludes: ["EXCLUÍDO", "EXCLUIDO"]
  },
  {
    letter: "F",
    kind: "occurrence",
    groupIds: ["11312"],
    typeIds: ["1019"],
    preferSingle: true,
    nameIncludes: ["ATRASO"]
  }
];

/** Catálogo Band v1 (SOCORRENCIAGRUPO / SOCORRENCIATIPO) — D/E abrem detalhe. */
export const BAND_REFO_CATALOG = {
  B: [{ idGroup: "8", idType: "1016", name: "Não Apresentou Tarefa" }],
  C: [
    { idGroup: "7", idType: "1015", name: "Falta de Material" },
    { idGroup: "2", idType: "243", name: "Falta de Material/Uniforme" }
  ],
  D: [
    {
      idGroup: "62",
      idType: "642",
      name: "Utilizar de maneira inadequada celular/equip. eletrônico."
    },
    {
      idGroup: "62",
      idType: "640",
      name: "Mostrar-se desengajado da proposta da aula."
    },
    {
      idGroup: "62",
      idType: "641",
      name: "Fazer uso de linguagem inadequada."
    },
    {
      idGroup: "62",
      idType: "643",
      name: "Praticar atividade estranha à aula."
    },
    {
      idGroup: "62",
      idType: "644",
      name: "Utilizar de maneira inadequada materiais e equipamentos."
    },
    {
      idGroup: "62",
      idType: "635",
      name: "Atrapalhar a aula com conversas/brincadeiras."
    },
    {
      idGroup: "62",
      idType: "636",
      name: "Agredir os colegas verbalmente e/ou com atiutdes"
    },
    { idGroup: "62", idType: "639", name: "Dormir na aula." },
    { idGroup: "62", idType: "638", name: "Desrespeitar o Professor." }
  ],
  E: [
    { idGroup: "61", idType: "1021", name: "Ausência de Uniforme" },
    {
      idGroup: "61",
      idType: "1020",
      name: "Reincidente em atitude inadequada"
    },
    { idGroup: "61", idType: "487", name: "Desrespeitar o professor." },
    {
      idGroup: "61",
      idType: "468",
      name: "Agredir os colegas verbalmente e/ou com atiutdes ."
    }
  ],
  F: [{ idGroup: "11312", idType: "1019", name: "Atraso" }]
};

function sameId(a, b) {
  return String(a) === String(b);
}

function upper(value) {
  return String(value || "").toUpperCase();
}

function collectFromType(type) {
  if (type.reasons && type.reasons.length) {
    return type.reasons.map(reason => ({
      idGroup: reason.idGroup,
      idType: reason.idType,
      name: reason.name
    }));
  }
  return [
    {
      idGroup: type.idGroup,
      idType: type.idType,
      name: type.name
    }
  ];
}

function matchesExact(type, def) {
  if (!def.groupIds || !def.typeIds) return false;
  return (
    def.groupIds.some(id => sameId(id, type.idGroup)) &&
    def.typeIds.some(id => sameId(id, type.idType))
  );
}

function matchesGroup(type, def) {
  if (!def.groupIds) return false;
  return def.groupIds.some(id => sameId(id, type.idGroup));
}

function matchesName(type, def) {
  if (!def.nameIncludes || !def.nameIncludes.length) return false;
  const haystack = [type.name]
    .concat((type.reasons || []).map(reason => reason.name))
    .map(upper)
    .join(" ");
  return def.nameIncludes.some(token => haystack.includes(upper(token)));
}

function optionKey(option) {
  return `${option.idGroup}:${option.idType}`;
}

function uniqueOptions(options) {
  const seen = new Set();
  return options.filter(option => {
    const key = optionKey(option);
    if (!option.idType || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function filterByDef(options, def) {
  if (!def.typeIds || !def.typeIds.length) return options;
  const filtered = options.filter(
    option =>
      def.groupIds.some(id => sameId(id, option.idGroup)) &&
      def.typeIds.some(id => sameId(id, option.idType))
  );
  return filtered.length ? filtered : options;
}

function sortRefoOptions(letter, options) {
  const catalog = BAND_REFO_CATALOG[letter] || [];
  const rank = new Map(catalog.map((item, index) => [optionKey(item), index]));
  return [...options].sort((a, b) => {
    const ra = rank.has(optionKey(a)) ? rank.get(optionKey(a)) : 999;
    const rb = rank.has(optionKey(b)) ? rank.get(optionKey(b)) : 999;
    if (ra !== rb) return ra - rb;
    return String(b.idType).localeCompare(String(a.idType), undefined, {
      numeric: true
    });
  });
}

function letterFromOptions(letter, def, rawOptions) {
  const options = sortRefoOptions(
    letter,
    filterByDef(uniqueOptions(rawOptions), def)
  );
  if (!options.length) {
    return { letter, kind: "unavailable" };
  }
  if (options.length === 1 || def.preferSingle) {
    const primary =
      (def.typeIds &&
        options.find(option => sameId(option.idType, def.typeIds[0]))) ||
      options[0];
    return {
      letter,
      kind: "occurrence",
      idGroup: primary.idGroup,
      idType: primary.idType,
      name: primary.name,
      aliases: options.filter(
        option => optionKey(option) !== optionKey(primary)
      )
    };
  }
  return { letter, kind: "occurrence", options };
}

export function resolveRefoLetters(types = []) {
  return REFO_LETTER_DEFS.map(def => {
    if (def.kind === "absence") {
      return { letter: def.letter, kind: "absence" };
    }

    const exact = types.filter(type => matchesExact(type, def));
    const byGroup = exact.length
      ? exact
      : types.filter(type => matchesGroup(type, def));
    const found = byGroup.length
      ? byGroup
      : types.filter(type => matchesName(type, def));
    const options = found.reduce(
      (acc, type) => acc.concat(collectFromType(type)),
      []
    );
    return letterFromOptions(def.letter, def, options);
  });
}

export function mergeRefoCatalog(types = []) {
  const letters = resolveRefoLetters(types);
  return letters.map(letter => {
    if (letter.kind === "absence") return letter;
    const catalog = BAND_REFO_CATALOG[letter.letter];
    if (!catalog) return letter;
    const def = REFO_LETTER_DEFS.find(item => item.letter === letter.letter);
    const current =
      letter.kind === "occurrence"
        ? letter.options || [
            {
              idGroup: letter.idGroup,
              idType: letter.idType,
              name: letter.name
            },
            ...(letter.aliases || [])
          ]
        : [];
    return letterFromOptions(letter.letter, def, current.concat(catalog));
  });
}

const BAND_OCCURRENCE_GROUPS = [
  { idGroup: "7", name: "Falta de Material", icon: "brush", letters: ["C"] },
  {
    idGroup: "8",
    name: "Não Apresentou Tarefa",
    icon: "assignment",
    letters: ["B"]
  },
  {
    idGroup: "62",
    name: "Atitude Inadequada",
    icon: "sentiment_very_dissatisfied",
    letters: ["D"]
  },
  {
    idGroup: "61",
    name: "Excluído da Sala de Aula",
    icon: "close",
    letters: ["E"]
  },
  { idGroup: "11312", name: "Atraso", icon: "access_time", letters: ["F"] }
];

function reasonsFromCatalog(idGroup, letters) {
  return uniqueOptions(
    letters.reduce(
      (acc, letter) => acc.concat(BAND_REFO_CATALOG[letter] || []),
      []
    )
  )
    .filter(item => sameId(item.idGroup, idGroup))
    .map(item => ({
      id: `${item.idType}-${item.idGroup}`,
      idGroup: item.idGroup,
      idType: item.idType,
      name: item.name
    }));
}

/** Grupos do diário v1 no formato do formulário de ocorrências v2. */
export function bandOccurrenceTypeGroups() {
  return BAND_OCCURRENCE_GROUPS.map(group => ({
    id: `-${group.idGroup}`,
    idGroup: group.idGroup,
    idType: "",
    name: group.name,
    icon: group.icon,
    reasons: reasonsFromCatalog(group.idGroup, group.letters),
    notificationPermission: false
  }));
}

export function mergeBandOccurrenceTypes(types = []) {
  const extras = bandOccurrenceTypeGroups();
  const byGroup = new Map(extras.map(group => [String(group.idGroup), group]));
  types.forEach(type => {
    const extra = byGroup.get(String(type.idGroup));
    if (!extra) {
      byGroup.set(String(type.idGroup), type);
      return;
    }
    const reasons = uniqueOptions(
      (type.reasons || []).concat(extra.reasons || [])
    ).map(item => ({
      id: item.id || `${item.idType}-${item.idGroup}`,
      idGroup: item.idGroup,
      idType: item.idType,
      name: item.name
    }));
    byGroup.set(String(type.idGroup), {
      ...extra,
      ...type,
      name: type.name || extra.name,
      reasons
    });
  });
  return Array.from(byGroup.values());
}

export function occurrenceMatchesLetter(occurrence, letter) {
  if (!occurrence || !letter || letter.kind !== "occurrence") return false;
  const options = letter.options
    ? letter.options
    : [
        { idGroup: letter.idGroup, idType: letter.idType },
        ...(letter.aliases || [])
      ];
  return options.some(
    option =>
      sameId(option.idGroup, occurrence.idGroup) &&
      sameId(option.idType, occurrence.idType)
  );
}

export function studentLetterMarks(student, letters) {
  const marks = {};
  letters.forEach(letter => {
    if (letter.kind === "absence") {
      marks[letter.letter] = !!student.absence;
      return;
    }
    if (letter.kind !== "occurrence") {
      marks[letter.letter] = false;
      return;
    }
    const found = (student.occurrences || []).find(occur =>
      occurrenceMatchesLetter(occur, letter)
    );
    marks[letter.letter] = found
      ? {
          idGroup: found.idGroup,
          idType: found.idType,
          description: found.description || ""
        }
      : false;
  });
  return marks;
}
